import {Component, ChangeDetectionStrategy, inject} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';

/**
 * Desktop-Navileiste unter dem Header ("Anzeige aufgeben", "Konto").
 * Die rechte Seite (Login-/Konto-Buttons) kommt per Content-Projection vom Frame.
 */
@Component({
    selector: 'kaz-desktop-nav',
    templateUrl: './kaz-desktop-nav.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent, RouterLink],
    host: {class: 'hidden h-16 w-full bg-[#FAFAFA] px-[60px] md:flex md:flex-row md:mb-14'}
})
export class KazDesktopNavComponent {
  private _router = inject(Router);

  activateAccountMenu() {
    return this._router.url.includes('login') || this._router.url.includes('signup') || this._router.url.includes('profile');
  }

  activateCreateAdMenu() {
    return this._router.url.includes('entry/create');
  }
}
